module.exports = __webpack_public_path__ + "static/media/wedding_march.0441f404.mp3";